import _ from "lodash";
import { HEAVY_METAL_TEST_ID, HEAVY_METAL_SPECIAL_PRICE } from "./bestDealConstants";
import { bundleReplacingFunc } from "./bundleReplacingAnyThreeAnyFiveSupportAtHomeOff";
import { bundleReplacingFuncDBS } from "./bundleReplacingAnyThreeAnyFivePromo";
import { bundleReplacingFuncNewVw } from "./bundleReplacingForNewVw";
import { addSelectedCustomPanel, removeSelectedCustomPanel } from "../testAndPanelSelection/customPanelSelection";
import { addSelectedDiscountPanel, removeSelectedDiscountPanel } from "../testAndPanelSelection/discountPanelSelection";
import { addSelectedSeasonalPromo, removeSelectedSeasonalPromo } from "../testAndPanelSelection/seasonalPromoSelection";
import { addSelectedTest, removeSelectedTest } from "../testAndPanelSelection/testSelection";
import { addSelectedXChooseYPanel, removeSelectedXChooseYPanel } from "../testAndPanelSelection/xChooseYPanelSelection";
import { addSelectedShortcut, removeSelectedShortcut } from "../testAndPanelSelection/shortcutSelection";
import { removeItem } from "../testAndPanelSelection";

export function handleBestDealSuggestion(selectProp, selectedItemPrice, supportObj, discountMap, isDbsVersion) {
  // get ids for selected test, test in selected custom, discount and x choose y panel
  let testIds = getTestIdsForBestDealFunc(supportObj);
  // console.log("testIds", testIds);
  if (testIds.length === 0) {
    return false;
  }
  let { suggestBundleList, leftOverTestIdList, bestDealPrice } = getSuggestBundlesAndLeftOverTestsForNewVw(testIds, supportObj, discountMap, isDbsVersion);
  // console.log("suggestBundleIds", suggestBundleList);
  // console.log("leftover tests", leftOverTestIdList);
  // this.lastTestIds = testIds;
  let isReplaced = replaceWithSuggestBundle(suggestBundleList, bestDealPrice, leftOverTestIdList, selectProp, supportObj, selectedItemPrice);
  // // this.checkAlbumin();
  // // this.$emit("handleIsSuggestionLoading", false);
  // // remove non-dbs version tests if isDbsVersion
  if (isDbsVersion) {
    removeNonDbsItem(selectProp, supportObj);
  }
  // console.log("end");
  return isReplaced;
}

// copy below this line to mjs //

// get ids for selected test, test in selected custom, discount and x choose y panel
export function getTestIdsForBestDealFunc(supportObj, testIdList = [], discountPanelIdList = []) {
  let { selectedTestIdList, testNodeList, selectedDiscountPanelIdList, bundleList, selectedXChooseYPanelIdList, selectedSeasonalPromoList, seasonalPromotionList, selectedCustomPanelIdList, selectedShortcutIdList, shortcutList } = supportObj;
  let idList = [];
  // add selected test ids
  // note that if provide testIdList, then use the provided one
  (testIdList.length > 0 ? testIdList : selectedTestIdList)?.forEach(id => {
    // find the node with the given id or originalId for duplicate tests
    let root = testNodeList.find(node => node.id === id || node.value.originalId === id);
    getBfsTestIds(root, idList);
  });
  // add test ids in discount panel
  (discountPanelIdList.length > 0 ? discountPanelIdList : selectedDiscountPanelIdList)?.forEach(panelId => {
    let panel = bundleList.find(b => b.bundleId === panelId);
    panel && panel.testIdsInPanel.forEach(id => {
      let root = testNodeList.find(node => node.id === id);
      getBfsTestIds(root, idList);
    });
  });
  // add test ids in xChooseYList
  selectedXChooseYPanelIdList?.forEach(panelId => {
    let panel = bundleList.find(b => b.bundleId === panelId);
    if (panel) {
      let idsInPanel = panel.selectedZoomerIdList
        .concat(panel.selectedSupplementIdList);
      idsInPanel.forEach(id => {
        let root = testNodeList.find(node => node.id === id);
        getBfsTestIds(root, idList);
      });
    }
  });
  // add test ids in seasonalPanels
  selectedSeasonalPromoList?.forEach(promo => {
    promo && promo.testIdsInPromo.forEach(id => {
      let root = testNodeList.find(node => node.id === id);
      getBfsTestIds(root, idList);
    });
  })
  // remove duplicate ids
  let uniqueIdList = [...new Set(idList)];
  // remove tests in custom panel
  selectedCustomPanelIdList?.forEach(panelId => {
    let panel = bundleList.find(b => b.bundleId === panelId);
    if (panel && panel.bundleItemList) {
      panel.bundleItemList.forEach(test => {
        if (test.itemType !== "official bundle") {
          let index = uniqueIdList.indexOf(test.itemId);
          if (index > -1) {
            uniqueIdList.splice(index, 1);
          }
        }
        else {
          let panel = bundleList.find(b => b.bundleId === test.itemId);
          let idsInPanel = panel.bundleContent.packageList.map(p => p.packageId)
            .concat(panel.bundleContent.testList.map(t => t.testId));
          idsInPanel.forEach(id => {
            let index = uniqueIdList.indexOf(id);
            if (index > -1) {
              uniqueIdList.splice(index, 1);
            }
          })
        }      
      });
    }
  })
  // remove tests in shortcuts
  selectedShortcutIdList?.forEach(shortcutId => {
    let shortcut = shortcutList.find(s => s.id === shortcutId);
    if (!shortcut) return;
    shortcut.testIdList.forEach(id => {
      let root = testNodeList.find(node => node.id === id);
      let testIds = [];
      getBfsTestIds(root, testIds);
      testIds.forEach(testId => {
        let index = uniqueIdList.indexOf(testId);
        if (index > -1) {
          uniqueIdList.splice(index, 1);
        }
      })
    });
    shortcut.discountPanelIdList.forEach(panelId => {
      let panel = bundleList.find(b => b.bundleId === panelId);
      let idsInPanel = panel.bundleContent.packageList.map(p => p.packageId)
        .concat(panel.bundleContent.testList.map(t => t.testId));
      idsInPanel.forEach(id => {
        let index = uniqueIdList.indexOf(id);
        if (index > -1) {
          uniqueIdList.splice(index, 1);
        }
      })
    });
    shortcut.customPanelIdList.forEach(panelId => {
      let panel = bundleList.find(bundle => bundle.bundleId === panelId);
      if (panel && panel.bundleItemList) {
        panel.bundleItemList.forEach(test => {
          if (test.itemType !== "official bundle") {
            let index = uniqueIdList.indexOf(test.itemId);
            if (index > -1) {
              uniqueIdList.splice(index, 1);
            }
          }
          else {
            let panel = bundleList.find(b => b.bundleId === test.itemId);
            let idsInPanel = panel.bundleContent.packageList.map(p => p.packageId)
              .concat(panel.bundleContent.testList.map(t => t.testId));
            idsInPanel.forEach(id => {
              let index = uniqueIdList.indexOf(id);
              if (index > -1) {
                uniqueIdList.splice(index, 1);
              }
            })
          }
        });
      }
    });
    shortcut.xChooseYIdList.forEach(item => {
      if (!item || !item.selectedZoomerIdList) {
        return;
      }
      item.selectedZoomerIdList.concat(item.selectedSupplementIdList).forEach(id => {
        let index = uniqueIdList.indexOf(id);
        if (index > -1) {
          uniqueIdList.splice(index, 1);
        }
      });
    });
  });  

  // remove non-breakable items's children if any
  [...uniqueIdList].forEach(id => {
    let node = testNodeList.find(node => node.id === id);
    if (node && node.value.notBreakable) {
      node.descendants.forEach(descendant => {
        removeItem(descendant.id, uniqueIdList);
      });
    }
  });
  return uniqueIdList;
}

export function getBfsTestIds(root, idList) {
  if (!root || !root.id) {
    return;
  }
  // special case: add specific albumn id if testo is selected
  if (root.value.testName === "Testo, Free [Incl. Total, Albumin, SHBG]") {
    idList.push("371_23");
  }
  if (root.value.notBreakable) {
    idList.push(root.id);
    return;
  }
  if (root.id === 60 || root.id === 151) {
    idList.push(60);
    return;
  }
  if (root.id === 586 || root.id === 594) {
    idList.push(586);
    return;
  }
  if (root.id === 727) {
    idList.push(727);
    return;
  }
  if (root.descendants.length === 0) {
    idList.push(root.id);
  }
  root.descendants.forEach(node => getBfsTestIds(node, idList));
}

// get suggest bundles and left over tests by looping the given testIds
export function getSuggestBundlesAndLeftOverTests(testIds, supportObj, discountMap, isDbsVersion, isAnyThreeDBSPromoStart, isHeavyMetalSpecialPrice) {
  let { testNodeList, bestDealSupportMapping } = supportObj;
  let { 
    dbs_x_choose_y_map, 
    ndbs_x_choose_y_map, 
    dbs_zoomer_main_price_info,
    dbs_zoomer_supplement_price_info,
    ndbs_zoomer_main_price_info,
    ndbs_zoomer_supplement_price_info
  } = bestDealSupportMapping
  let allSuggestions = getAllDiscountPanelSuggestions(testIds, discountMap, supportObj);
  let vaTestList = testNodeList.filter(node => node.value.category === "va").map(node => node.value);
  let vwTestList = testNodeList.filter(node => node.value.category === "vw").map(node => node.value);
  const bestSuggestion = isDbsVersion ? 
    bundleReplacingFuncDBS(allSuggestions,testIds,vaTestList,vwTestList, isDbsVersion, testNodeList, dbs_x_choose_y_map, dbs_zoomer_main_price_info, dbs_zoomer_supplement_price_info, isHeavyMetalSpecialPrice)
    : bundleReplacingFunc(allSuggestions,testIds,vaTestList,vwTestList, isDbsVersion, testNodeList, ndbs_x_choose_y_map, ndbs_zoomer_main_price_info, ndbs_zoomer_supplement_price_info, isHeavyMetalSpecialPrice)
  // console.log(bestSuggestion,'bestSuggestion');
  if (!bestSuggestion.appliedBundles) {
    bestSuggestion.appliedBundles = [];
  }
  if (!bestSuggestion.remainingNewValues) {
    bestSuggestion.remainingNewValues = testIds;
  }
  // this.currentBestSuggestion = bestSuggestion;
  let suggestBundleList = bestSuggestion.appliedBundles;
  // replace with parent tests for remainingNewValues
  // let leftOverTestIdList = getLeftOverTests(bestSuggestion.remainingNewValues, supportObj);
  let leftOverTestIdList = bestSuggestion.remainingNewValues;
  let leftOverTestPrice = testNodeList.filter(node => leftOverTestIdList.includes(Number(node.id)))
    .reduce((acc, node) => acc + (isHeavyMetalSpecialPrice && node.id === HEAVY_METAL_TEST_ID ? HEAVY_METAL_SPECIAL_PRICE : node.value.price), 0);
  let bestDealPrice = bestSuggestion.priceAfterAppliedBundle ? bestSuggestion.priceAfterAppliedBundle : leftOverTestPrice;
  return { suggestBundleList, leftOverTestIdList, bestDealPrice};
}

// get suggest bundles and left over tests by looping the given testIds for new_vw beta users
// This version filters out discount panel suggestions since discount panels are hidden for new_vw users
export function getSuggestBundlesAndLeftOverTestsForNewVw(testIds, supportObj, discountMap, isDbsVersion) {
  let { testNodeList, bundleList } = supportObj;
  // filter bundles according to isDbsVersion
  let filteredBundleList = bundleList.filter(panel => {
    let sections = isDbsVersion ? ["at_home", "both"] : ["not_at_home", "both"];
    return sections.includes(panel.section) && !panel.toBeOffline;
  });
  let allSuggestions = getAllDiscountPanelSuggestions(testIds, discountMap, supportObj);

  // Use unified bundle replacing function for new_vw (no need to check isDbsVersion)
  // Filtering out discount panel suggestions and removing duplicates is handled inside bundleReplacingFuncNewVw
  const bestSuggestion = bundleReplacingFuncNewVw(
    allSuggestions,
    testIds,
    testNodeList,
    filteredBundleList
  );
  // console.log(bestSuggestion,'bestSuggestion');
  if (!bestSuggestion.appliedBundles) {
    bestSuggestion.appliedBundles = [];
  }
  if (!bestSuggestion.remainingNewValues) {
    bestSuggestion.remainingNewValues = testIds;
  }
  // this.currentBestSuggestion = bestSuggestion;
  let suggestBundleList = bestSuggestion.appliedBundles;
  // replace with parent tests for remainingNewValues
  // let leftOverTestIdList = getLeftOverTests(bestSuggestion.remainingNewValues, supportObj);
  let leftOverTestIdList = bestSuggestion.remainingNewValues;
  // Calculate leftover test prices (special prices are already included in test.value.price)
  let leftOverTestPrice = testNodeList.filter(node => leftOverTestIdList.includes(Number(node.id)))
    .reduce((acc, node) => acc + node.value.price, 0);
  let bestDealPrice = bestSuggestion.priceAfterAppliedBundle ? bestSuggestion.priceAfterAppliedBundle : leftOverTestPrice;
  return { suggestBundleList, leftOverTestIdList, bestDealPrice};
}

// replace tests with its parents if available
export function replaceWithParentTests(remainingTestIdList, testNodeList, totalToxReplace = false) {
  let leftOverTestIdSet = new Set([...remainingTestIdList]);
  let remainingTestNodes = testNodeList.filter(node => remainingTestIdList.includes(node.id));
  let deepestLevel = Math.max(...remainingTestNodes.map(node => node.level));
  for (let i = deepestLevel; i > 0; i--) {
    let currentLevelNodes = remainingTestNodes.filter(node => node.level === i);
    currentLevelNodes.forEach(node => {
      let descendantList = node.parent.descendants;
      if (leftOverTestIdSet.has(node.parent.id)) {
        // remove the parent's descendants if any
        descendantList.forEach(d => {
          leftOverTestIdSet.delete(d.id);
        });
        return;
      }
      if (node.parent.value.notBreakable) {
        return;
      }
      let isAllDescendantsRemaining = descendantList.every(d => leftOverTestIdSet.has(d.id));
      if (isAllDescendantsRemaining) {
         // total tox will not be replaced with its parent
         if(node.parent.id === 828 && !totalToxReplace) {
          return
        }
        // replace with parent
        descendantList.forEach(d => {
          leftOverTestIdSet.delete(d.id);
        });
        leftOverTestIdSet.add(node.parent.id);
      }
    });
    remainingTestNodes = testNodeList.filter(node => leftOverTestIdSet.has(node.id));
  }
  return [...leftOverTestIdSet];
}
export function getAllDiscountPanelSuggestions(testIds, discountMap, supportObj) {
  let { seasonalPromotionList, bundleList, testNodeList } = supportObj;
  let allSuggestions = [];
  testIds.forEach(id => {
    let bundleSuggestion = discountMap[id.toString()];
    if (bundleSuggestion) {
      const bundleSuggestionDetails = bundleSuggestion.map((i) => {
        let result = {};
        if (i < 0) {
          // for seasonal promos
          result = seasonalPromotionList.find(p => p.bundleId === i);
        }
        else {
          result = bundleList.find((t) => t.bundleId === i);
        }
        if (result) {
          if (i < 0) {
            // for seasonal promos
            let idList = [];
            result.testIdsInPromo.forEach(id => {
              let testNode = testNodeList.find(node => node.id === id);
              getBfsTestIds(testNode, idList);
            });
            return {
              bundleId: result.bundleId,
              name: result.discountName,
              originPrice: result.originalPrice,
              finalPrice: result.price,
              quantity: result.quantity,
              testIdsInPromo: idList,
              supplementList: result.supplementContent && result.supplementContent.itemIdList
            }
          }
          const { packageList, testList } = result.bundleContent;
          let idsInPanel = packageList.map(p => p.packageId).concat(testList.map(t => t.testId));
          let testIds = [];
          if (result.category === "xChooseY") {
            testIds = idsInPanel;
          } else {
            idsInPanel.forEach(id => {
              let root = testNodeList.find(node => node.id === id);
              getBfsTestIds(root, testIds);
            });
          }
          let uniqueTestIds = [...new Set(testIds)]; // remove test ids
          return {
            bundleId: result.bundleId,
            name: result.bundleName,
            originPrice: result.originalPrice,
            finalPrice: result.price,
            bundleContentIds: uniqueTestIds,
            quantity: result.quantity,
            supplementList: result.supplementContent && result.supplementContent.itemIdList,
            supplementQuantity: result.supplementQuantity
          };
        }
      });
      allSuggestions = allSuggestions.concat(bundleSuggestionDetails.filter(e => Boolean(e)));
    }
  });
  return allSuggestions;
}
// copy above this line to mjs //

// replace user selected tests whith suggested bundles and leftover tests
// return a boolean value to reprensent selected tests are replaced by best deal or not
function replaceWithSuggestBundle(suggestBundleList, bestDealPrice, leftOverTestIdList, selectProp, supportObj, selectedItemPrice) {
  let { selectedDiscountPanelIdList, selectedCustomPanelIdList, seasonalPromotionList, bundleList, selectedTestIdList, selectedSeasonalPromoList, selectedXChooseYPanelIdList, selectedShortcutIdList } = supportObj;
  let suggestBundleIds = suggestBundleList.map(bundle => bundle.appliedBundleId);
  // get current selected bundle ids (except for custom panel)
  let selectedBundleIds = selectedDiscountPanelIdList
    .concat(selectedSeasonalPromoList.map(promo => promo.bundleId))
    .concat(selectedXChooseYPanelIdList);
  let allSuggestBundlesSelect = suggestBundleIds.length === selectedBundleIds.length && selectedBundleIds.every(id => suggestBundleIds.find(i => i === id));
  // compare selected tests with leftover
  // let allLeftOverTestsSelect = leftOverTestIdList.length === selectedLeafTestIds.length && selectedLeafTestIds.every(id => leftOverTestIdList.find(i => i === id));
  let allLeftOverTestsSelect =  selectedTestIdList.every(id => leftOverTestIdList.find(i => i === id));
  // if all suggest bundles and left over tests are already selected, return
  if (allSuggestBundlesSelect && allLeftOverTestsSelect) {
    return false;
  }
  // compare best deal and current price
  // console.log("deal price", bestDealPrice);
  // console.log("current price", Number(selectedItemPrice.toFixed(2)));
  // no need to replace if best deal is expensive
  if (Number(bestDealPrice) > Number(selectedItemPrice.toFixed(2))) {
    return false;
  }
  // if best deal and current selected tests have same price,
  // then best deal is the parent nodes for current tests, so replace
  let isReplacedByParent = Number(bestDealPrice) == Number(selectedItemPrice.toFixed(2));
  //console.log("replace")
  let selectedCustomPanelIds = [...selectedCustomPanelIdList];
  let selectedShortcutIds = [...selectedShortcutIdList];
  // remove all selected items first
  clearAllSelectedItems(selectProp, supportObj);
  // console.log("after clear", [...selectedTestIdList]);
  // add back custom panels and shortcuts
  selectedCustomPanelIds.forEach(panelId => {
    addSelectedCustomPanel(panelId, selectProp, supportObj);
  });
  selectedShortcutIds.forEach(shortcutId => {
    addSelectedShortcut(shortcutId, selectProp, supportObj);
  });  
  // add all suggest bundles
  suggestBundleList.forEach(suggestBundle => {
    let bundleId = suggestBundle.appliedBundleId;
    let foundPanel = (bundleId < 0 ? seasonalPromotionList : bundleList)
      .find(panel => panel.bundleId === bundleId);
    if (foundPanel) {
      if (foundPanel.category === "discountPanel") {
        addSelectedDiscountPanel(bundleId, selectProp, supportObj);
      }
      else if (foundPanel.category === "xChooseY") {
        let { appliedZoomers, appliedSupplement } = suggestBundle;
        foundPanel.selectedZoomerIdList = appliedZoomers;
        foundPanel.selectedSupplementIdList = appliedSupplement;
        addSelectedXChooseYPanel(bundleId, selectProp, supportObj);
      }
      else if (foundPanel.category === "seasonalPromo") {
        let promo = seasonalPromotionList.find(p => p.bundleId === bundleId);
        if (suggestBundle.appliedZoomers) {
          promo.appliedTests = suggestBundle.appliedZoomers;
        }
        addSelectedSeasonalPromo({ ...promo }, selectProp, supportObj);
      }
    }
  });
  // console.log("after add bundles", [...selectedTestIdList]);
  // add all left over tests
  // console.log(leftOverTestIdList)
  leftOverTestIdList.forEach(id => {
    addSelectedTest(id, selectProp, supportObj);
  });
  // return true if tests replaced due to a cheaper deal,
  // return false if tests replaced by parents
  return isReplacedByParent ? false : true;
}

export function clearAllSelectedItems(selectProp, supportObj) {
  let { selectedTestIdList, selectedDiscountPanelIdList, selectedCustomPanelIdList, selectedXChooseYPanelIdList, selectedSeasonalPromoList, selectedShortcutIdList, bundleList } = supportObj;
  [...selectedCustomPanelIdList].forEach(panelId => {
    removeSelectedCustomPanel(panelId, selectProp, supportObj);
  });
  [...selectedShortcutIdList].forEach(shortcutId => {
    removeSelectedShortcut(shortcutId, selectProp, supportObj);
  });  
  [...selectedSeasonalPromoList].forEach(promo => {
    removeSelectedSeasonalPromo(promo, selectProp, supportObj);
  });
  [...selectedXChooseYPanelIdList].forEach(panelId => {
    let xChooseYPanel = bundleList.find(b => b.bundleId === panelId);
    // remove xChooseYPanel with selected zoomer id
    if (xChooseYPanel.selectedZoomerIdList.length > 0) {
      removeSelectedXChooseYPanel(panelId, selectProp, supportObj);
    }
  });
  [...selectedDiscountPanelIdList].forEach(panelId => {
    removeSelectedDiscountPanel(panelId, selectProp, supportObj);
  });
  [...selectedTestIdList].forEach(testId => {
    removeSelectedTest(testId, selectProp, supportObj);
  });
}

function removeNonDbsItem(selectProp, supportObj) {
  let { selectedItemList, dbsMap } = supportObj;
  selectedItemList.forEach(item => {
    let id = item.id ? item.id : item.bundleId;
    let isDbs = dbsMap.find(map => map.dbsItemId === id);
    let { blood, dryIce } = item.sampleTypeSets;
    if (!isDbs && (blood.size > 0 || dryIce.size > 0)) {
      switch(item.category) {
        case "va":
        case "vw":
          removeSelectedTest(id, selectProp, supportObj);
          break;
        case "discountPanel":
          removeSelectedDiscountPanel(id, selectProp, supportObj);
          break;
        case "xChooseY":
          removeSelectedXChooseYPanel(id, selectProp, supportObj);
          break;
        default:
          return;
      }
    }
  })
}
